import { masks, onlyNumbers } from 'components/label/masks'
import * as React from 'react'

import { MaskedField, MaskedFieldProps } from '../final-form'

export const ChaveField = (props: MaskedFieldProps) => {
  return <MaskedField mask={masks.chave} parse={onlyNumbers} {...props} />
}
